import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'boostersManageClick',
  'boostersAddClick',
  'boostersContinueClick',
  'generalModalBoostersBannerShown',
  'boostersEditorNoActivityBannerShown',
  'boostersDashboardBannerShown',
  'minutesBoostersCounterHover',
] as const;

export const boosterEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
